<template>
    <div class="company-warehouse-registration-list-table">
        <el-table
            :data="processingQueue"
            :empty-text="translate('no_data')"
            highlight-current-row
        >
            <el-table-column
                min-width="150px"
                prop="nomeArquivo"
                :label="translate('file_name')"
                label-class-name="company-warehouse-registration-list-table_label"
            />
            <el-table-column
                min-width="150px"
                prop="nomeUsuario"
                :label="translate('responsible_name')"
                label-class-name="company-warehouse-registration-list-table_label"
            >
                <template v-slot:default="scope">
                    <div v-if="scope.row.nomeUsuario">
                        <div class="file-list_text">
                            {{ scope.row.nomeUsuario }}
                        </div>
                        <div class="table_second-row-label file-list_text">
                            {{ scope.row.emailUsuario }}
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="90px"
                prop="dataInicioProcessamento"
                :label="translate('processing_start_date')"
                label-class-name="company-warehouse-registration-list-table_label"
            >
                <template v-slot:default="scope">
                    <div v-if="scope.row.dataInicioProcessamento">
                        <div>
                            {{ formatDateTimeToString(scope.row.dataInicioProcessamento )[0] }}
                        </div>
                        <div class="table_second-row-label">
                            <i class="mdi mdi-clock-outline"></i>
                            {{ formatDateTimeToString(scope.row.dataInicioProcessamento )[1] }}
                        </div>
                    </div>
                    <span v-else> - </span>
                </template>
            </el-table-column>
            <el-table-column
                min-width="90px"
                prop="dataFimProcessamento"
                :label="translate('processing_end_date')"
                label-class-name="company-warehouse-registration-list-table_label"
            >
                <template v-slot:default="scope">
                    <div v-if="scope.row.dataFimProcessamento">
                        <div>
                            {{ formatDateTimeToString(scope.row.dataFimProcessamento )[0] }}
                        </div>
                        <div class="table_second-row-label">
                            <i class="mdi mdi-clock-outline"></i>
                            {{ formatDateTimeToString(scope.row.dataFimProcessamento )[1] }}
                        </div>
                    </div>
                    <span v-else> - </span>
                </template>
            </el-table-column>
            <el-table-column
                width="150px"
                prop="status"
                :label="translate('status')"
                label-class-name="company-warehouse-registration-list-table_label"
            >
                <template v-slot:default="scope">
                    <el-tag
                        :class="'tag-status-' + scope.row.status.toLowerCase()"
                        type="primary" size="small"
                        :round="false"
                    >
                        {{ getStatusLabel(scope.row.status) }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column
                width="90px"
                :label="translate('actions')"
                align="center"
                label-class-name="company-warehouse-registration-list-table_label"
            >
                <template v-slot:default="scope">
                    <el-dropdown
                        class="action-button"
                        trigger="click"
                        @click="scope"
                    >
                        <span class="el-dropdown-link">
                            <i class="mdi mdi-dots-vertical" />
                        </span>
                        <el-dropdown-menu v-slot="dropdown">
                            <el-dropdown-item
                                icon="el-icon-download"
                                @click.native="downloadSpreadsheet(scope.row, false)"
                            >
                                {{ translate('download_original_spreadsheet') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="scope.row.status === 'PROCESSADO_COM_ERRO'"
                                icon="el-icon-download"
                                @click.native="downloadSpreadsheet(scope.row, true)"
                            >
                                {{ translate('downaload_error_spreadsheet') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <div class="company-warehouse-registration-list-table__pagination">
            <div class="total">
                <span
                    >{{ totalElements }}
                    {{
                        translate('results')
                    }}</span
                >
                <div style="margin: 0 20px"></div>
                <span
                    >{{
                        translate('views_by_page')
                    }}:</span
                >
                <el-pagination
                    @size-change="handleSizeChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="sizes"
                    :total="totalElements"
                />
            </div>
            <div class="prev_next">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="prev, pager, next, jumper"
                    :total="totalElements"
                />
            </div>
        </div>
    </div>
</template>

<script>
import RastreabilidadeFilaProcessamentoPlanilhaService from '@/services/RastreabilidadeFilaProcessamentoPlanilhaService';
import formatters from '@/utils/formatters';

export default {
    name: 'CompanyWarehouseRegistrationList',
    components: {
    },
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            processingQueue: [],
            page: 0,
            size: 10,
            totalElements: 0
        };
    },
    computed: {
    },
    mounted() {
        this.fetchingRegistrationList();
    },
    watch: {
        filters: {
            handler(newVal) {
                this.fetchingRegistrationList();
            },
            deep: true
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse.warehouse_registration_page.table';
            return this.$t(`${base}.${key}`, params);
        },
        handleSizeChange(size) {
            this.page = this.totalElements < size ? 1 : this.page;
            this.size = size;
            this.fetchingRegistrationList();
        },
        handleCurrentChange(page) {
            this.page = page;
            this.fetchingRegistrationList();
        },
        async fetchingRegistrationList() {
            if (this.filters) {
                RastreabilidadeFilaProcessamentoPlanilhaService.fetchProcessingQueuePaginated(
                    {
                        searchText: this.filters.searchText,
                        status: this.filters.fileProcessingStatus.length > 0 ? this.filters.fileProcessingStatus[0] : null,
                        tipoArquivoCodigo: this.filters.fileType,
                        dataInicio: this.filters.initialDate_initial,
                        dataFim: this.filters.endDate_initial
                    },
                    (this.page - 1), this.size
                ).then(({ data }) => {
                    this.processingQueue = data.itens;
                    this.totalElements = data.totalItens;
                });
            }
        },
        getStatusLabel(status) {
            return this.translate('status_label.' + status.toLowerCase());
        },
        async downloadSpreadsheet(row, planilhaErro = false) {
            let nomeArquivo = row.nomeArquivo;
            if (planilhaErro) {
                if (row.idiomaUsuario === 'pt-BR') {
                    nomeArquivo = 'ERRO_' + nomeArquivo;
                } else {
                    nomeArquivo = 'ERROR_' + nomeArquivo;
                }
            }
            await RastreabilidadeFilaProcessamentoPlanilhaService.getWarehouseVatchUploadSpreadsheet(row.id, nomeArquivo, planilhaErro)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('warehouse.messages.file_downloaded_successfully')
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t('warehouse.messages.error_downloading_file')
                    })
                );
        },
        formatDateTimeToString(dateTimeFromApi) {
            return formatters.splitApiDateTimeForTable(dateTimeFromApi, this.$i18n.locale);
        }
    }
};
</script>

<style scoped lang="scss">
.company-warehouse-registration-list-table {
    margin-top: -8px;
    .el-table {
        .action-button {
            cursor: pointer;
        }
    }
    .company-warehouse-registration-list-table__pagination {
        display: grid;
        grid-template-columns: 2fr auto;
        margin-top: 20px;
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .total {
            display: flex;
            align-items: center;
            @media (max-width: 768px) {
                flex-direction: column;
            }
        }

        .prev_next {
            display: flex;
            @media (max-width: 768px) {
                justify-content: center;
                margin-top: 20px;
            }
        }
    }
}
.level1-label {
    font-size: 12px;
    color: #7c7c7c !important;
}
::v-deep .company-warehouse-registration-list-table_label {
    word-break: keep-all !important;
}
.file-list_text {
    word-break: keep-all !important;
}
.tag-status-solicitado {
    color: #525252;
    background-color: transparent;
    border: 1px solid #E0E0E0;
    border-radius: 4px !important;
}
.tag-status-em_processamento {
    color: #525252;
    background-color: #F5F5F5;
    border: 1px solid #E0E0E0;
    border-radius: 4px !important;
}
.tag-status-processado {
    color: #1F5B21;
    background-color: #EBF4EB;
    border: 1px solid #C0DDC1;
    border-radius: 4px !important;
}
.tag-status-processado_com_erro {
    color: #6D4D09;
    background-color: #FDF7E8;
    border: 1px solid #F9E5B9;
    border-radius: 4px !important;
}
.tag-status-erro {
    color: #991F1A;
    background-color: #FCEBEA;
    border: 1px solid #F4C1BE;
    border-radius: 4px !important;
}
.table_second-row-label {
    color: #7C7C7C !important;
    font-size: 12px;
}

.tag-status-solicitado {
    color: #525252;
    background-color: transparent;
    border: 1px solid #E0E0E0;
    border-radius: 4px !important;
}
.tag-status-em_processamento {
    color: #525252;
    background-color: #F5F5F5;
    border: 1px solid #E0E0E0;
    border-radius: 4px !important;
}
.tag-status-processado {
    color: #1F5B21;
    background-color: #EBF4EB;
    border: 1px solid #C0DDC1;
    border-radius: 4px !important;
}
.tag-status-processado_com_erro {
    color: #6D4D09;
    background-color: #FDF7E8;
    border: 1px solid #F9E5B9;
    border-radius: 4px !important;
}
.tag-status-erro {
    color: #991F1A;
    background-color: #FCEBEA;
    border: 1px solid #F4C1BE;
    border-radius: 4px !important;
}
.company-list-item {
    font-size: 11px;
}
</style>
